import { Box, Typography } from '@mui/material';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { Link as RouterLink } from 'react-router-dom';

import { PRIMARY_BUTTON_SX } from '../Samples/SampleBanner';
import { heldOutLine, matchesLine } from './matchRows';
import { DATA_REVIEW, MATCHES_ROUTE } from './dataReviewTokens';

export const STRIP_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  padding: '16px 20px',
  borderRadius: '12px',
  bgcolor: DATA_REVIEW.stripBg,
  color: DATA_REVIEW.stripFg,
} as const;

export function MatchesCallout({ toReview, heldOutStudents }: { toReview: number; heldOutStudents: number }) {
  if (toReview <= 0) return null;
  return (
    <Box role="status" data-testid="matches-callout" sx={STRIP_SX}>
      <PeopleOutlineIcon sx={{ alignSelf: 'flex-start', flexShrink: 0, width: 24, height: 24, color: DATA_REVIEW.stripIcon }} />
      <Box sx={{ flex: '1 1 auto', minWidth: 0, display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <Typography component="b" sx={{ fontSize: 16, lineHeight: '24px', fontWeight: 700 }}>
          {matchesLine(toReview)}
        </Typography>
        <Typography component="span" sx={{ fontSize: 15, lineHeight: '22px' }}>
          {heldOutLine(heldOutStudents)}
        </Typography>
      </Box>
      <Box component={RouterLink} to={MATCHES_ROUTE} sx={{ ...PRIMARY_BUTTON_SX, flexShrink: 0 }}>
        Review matches
      </Box>
    </Box>
  );
}
